<script setup lang="ts">
import { computed, ref } from 'vue'
import type { FieldConfig, FieldCreatorType, FormCreatorType } from '../../../../../Types/form'
import EntityAddressFormDialog from '../../Entity/EntityAddressFormDialog.vue'
import ButtonAll from '../../UI/Button/ButtonAll.vue'
import FieldCreator from '../../UI/Form/FieldCreator.vue'

const props = withDefaults(
  defineProps<{
    form: FormCreatorType
    entityId: number
    labelTop?: boolean
    labelLeft?: boolean
  }>(),
  { labelTop: true, labelLeft: false },
)

const displayAddressForm = ref(false)
const field = ref<FieldCreatorType>()

const readonly = computed<boolean>(() => {
  const config = field.value?.field as FieldConfig | undefined

  return true === config?.options.disabled
})

function openAddressForm() {
  displayAddressForm.value = true
}

function closeAddressForm() {
  displayAddressForm.value = false
}

function addAddressAsOption({ address }: { address: Address }) {
  displayAddressForm.value = false
  field.value?.addOption(new Option(address.name, String(address.id), true, true))

  // @ts-ignore
  props.form.datas['deliveryAddress'] = address.id
}
</script>

<template>
  <FieldCreator
    ref="field"
    :form-data="form"
    name="deliveryAddress"
    form-ref="formcontract"
    domain="contract"
    :label-left="labelLeft"
    :label-top="labelTop"
  >
    <template v-if="!readonly" #add>
      <div class="btn-group">
        <ButtonAll type="add" icon="add" margin="no" class="ml-2" @click="openAddressForm" />
      </div>
    </template>
  </FieldCreator>

  <EntityAddressFormDialog
    v-if="displayAddressForm"
    :entity-id="entityId"
    @close="closeAddressForm"
    @save="addAddressAsOption"
  />
</template>
